export const environment = {
  production: false,
  apiUrl: 'https://misfacturacionapidev.clavisco.com/',
  LogRocketId: ''
};
